export default "__VITE_ASSET__uT_ocHI9__"